import Image, { type StaticImageData } from "next/image";

export interface SNSProps {
  type: "DogRound" | "DogWithBorder" | "GraphicWithBorder" | "DogPlus";
  showBorder: boolean;
  image?: string | StaticImageData;
  className?: string;
  imageClassName?: string;
  onClick?: () => void;
}

export const PetImageAtom: React.FC<SNSProps> = ({
  type,
  showBorder,
  image,
  imageClassName,
  className,
  onClick,
}) => {
  return (
    <section className="">
      {type && (
        <div
          className={`${
            showBorder == true &&
            " rounded-full border-[4px] border-[#FADB14] bg-white"
          } flex items-center justify-center ${
            className ?? " h-[65px] w-[65px] "
          }`}
          onClick={onClick}
        >
          <div
            className={`${
              imageClassName ?? ""
            } relative flex items-center justify-center overflow-hidden rounded-full`}
          >
            <Image
              src={image ? image : ""}
              alt={`${type}`}
              objectFit="cover"
              fill
            />
          </div>
        </div>
      )}
    </section>
  );
};
